import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, RouterEvent, NavigationEnd } from '@angular/router';
import { AnalyticsService } from 'services/analytics/analytics.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  
  public isNavbarOpen: boolean = false;
  public isStickyNavbarVisible: boolean = false;
  public year: number = new Date().getFullYear();

  private readonly stickyNavbarThreshold: number = 0;

  constructor(private router: Router) {
    // Page change tracking by the analytics service
    this.router.events.subscribe((event: RouterEvent) => {
      if (event instanceof NavigationEnd) {
        AnalyticsService.trackPage(event.urlAfterRedirects);
      }
    });
  }

  public ngOnInit(): void {
    window.addEventListener('scroll', this.setStickyNavbar, true);
  }

  public ngOnDestroy(): void {
    window.removeEventListener('scroll', this.setStickyNavbar, true);
  }

  public scrollTo(element: any): void {
    element.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    this.closeNavbar();
  }

  public toggleNavbar(): void {
    this.isNavbarOpen = !this.isNavbarOpen;
  }

  public gotToAppStore(): void {
    window.open('https://itunes.apple.com/pt/app/shopper-by-fashion-concierge/id1301253477?mt=8', '_blank');
  }

  public gotToEmail(): void {
    window.open('mailto:dl-pt-fc-tech-it@farfetch.com', '_top');
  }

  private setStickyNavbar = (event: any): void => {
    const pos = event.srcElement.scrollingElement.scrollTop;
    this.isStickyNavbarVisible = pos > this.stickyNavbarThreshold;
  }

  private closeNavbar(): void {
    this.isNavbarOpen = false;
  }
}
